import React, { useState, useEffect, useMemo } from "react";
import JoditEditor from "jodit-react";
const CodeEditor = ({ placeholder, value, onChange }) => {
  const [content, setContent] = useState(value || "");

  const config = useMemo(
    () => ({
      readonly: false,
      toolbarAdaptive: false,
      placeholder: placeholder || "Enter description ...",
      uploader: {
        insertImageAsBase64URI: true,
      },

      buttons:
        "source,bold,italic,underline,|,ul,ol,|,font,fontsize,|,table,|,align,left,center,right,",
    }),
    [placeholder]
  );

  const handleEditorChange = (newContent) => {
    const safeContent = newContent || "";
    setContent(safeContent);
    if (typeof onChange === "function") {
      onChange(safeContent);
    }
  };

  useEffect(() => {
    setContent(value || "");
  }, [value]);

  return (
    <div style={{ width: "100%", height: "100%" }}>
      <JoditEditor
        value={content}
        config={config}
        tabIndex={1}
        onBlur={() => { }}
        onChange={handleEditorChange}
      />
    </div>
  );
};

export default CodeEditor;
